import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: "app-paginator",
  templateUrl: "./paginator.component.html",
  styleUrls: ["./paginator.component.scss"],
})
export class PaginatorComponent implements OnInit {
  @Input() queryParams: any;
  @Input() count = 0;
  @Input() filter = "";
  @Input() type: "default" | "squared" = "default";
  @Input() displayPageSize = true;
  @Input() optionSize = [10, 30, 50, 100];
  @Input() showDisplayedCount = false;
  
  @Output() query: EventEmitter<any> = new EventEmitter();
  
  pageSize = 1;
  page = 1;
  perPage = 10;

  currentSizePage = 1;
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.queryParams) {
      this.queryParams = changes.queryParams.currentValue;

      this.page = this.queryParams.page || 1;
      this.perPage = this.queryParams.top || this.perPage;
      
      this.currentSizePage = this.optionSize.findIndex(f => f === this.queryParams.perPage) + 1;
    }
  }

  ngOnInit(): void {
    this.perPage = this.queryParams.top;
  }

  pageChange() {
    this.queryParams.page = this.page;
    this.queryParams.top = this.perPage;
    this.queryParams.skip = this.perPage * (this.page - 1);
    this.queryParams.filter = this.filter ?? '';

    this.query.emit(null);
  }

  getPageLabel(size) {
    return this.optionSize[size - 1];
  }

  sizePageChange(e) {
    this.perPage = this.optionSize[e - 1];
    this.queryParams.top = this.perPage;
    this.query.emit(null);
  }

  handleCustomSizePageChanged() {
    this.page = 1;
    this.perPage = +this.perPage;
    this.queryParams.top = +this.perPage;
    this.queryParams.page = 1;
    this.queryParams.skip = 0;
    this.queryParams.filter = this.filter ?? '';
    
    this.query.emit(null);
  }

  get showingCount(): number {
    const total = Number(this.count) || 0;
    const size = Number(this.perPage) || 0;
    const currentPage = Number(this.page) || 1;
    const skip = size * (currentPage - 1);
    return Math.max(0, Math.min(size, total - skip));
  }

  maxPage(): number {
    return Math.ceil(this.count / this.perPage);
  }
}
